import { $authHost } from ".";

export const updatePrice = async (formData) => {
    const { data } = await $authHost.post("/pdf/upload", formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
    return data;
};